import React from "react";

const DivisionIcon = ({
  width = "14px",
  height = "14px",
  fill = "#B0B3C7",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5934_18751)">
        <path
          d="M11.1962 7.87018L7.65717 6.92188L5.06641 9.51264L6.01471 13.0517L9.55373 14L12.1445 11.4092L11.1962 7.87018Z"
          fill={fill}
        />
        <path
          d="M6.12979 2.79984L2.59077 1.85156L0 4.44233L0.948281 7.98135L4.48733 8.92966L7.07809 6.33889L6.12979 2.79984Z"
          fill={fill}
        />
        <path
          d="M13.0517 0.948281L9.51264 0L6.92188 2.59077L7.87018 6.12979L11.4092 7.07809L14 4.48733L13.0517 0.948281Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_5934_18751">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DivisionIcon;
